import { render, staticRenderFns } from "./PartnerWall.vue?vue&type=template&id=0e754679&scoped=true"
import script from "./PartnerWall.vue?vue&type=script&lang=js"
export * from "./PartnerWall.vue?vue&type=script&lang=js"
import style0 from "./PartnerWall.vue?vue&type=style&index=0&id=0e754679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e754679",
  null
  
)

export default component.exports